/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useEffect } from "react";
import $ from 'jquery';
import MetaTags from 'react-meta-tags';

function Smart() {
	useEffect(() => {
		$(".tab_smart .tab_a").click(function () {
			$(this).addClass("select").siblings().removeClass("select");
		});
		$(".vision_con .vc_w").css("height", "300px")

		return (() => {
			$(".vision_con .vc_w").css("height", "200px")
		})
	})

	return (
		<>
			<MetaTags>
				<title>中華電信i寶貝智慧聲控-親聲體驗</title>
				<meta name="keywords" content="i寶貝線上體驗,親聲體驗,線上體驗,智慧聲控,聲控體驗"></meta>
				<meta name="description" content="中華電信i寶貝智慧聲控服務的線上體驗。您將可以親自感受到i寶貝智慧聲控的服務。" />
				<meta property="og:title" content="中華電信i寶貝智慧聲控-親聲體驗" />
				<meta property="og:Description" content="中華電信i寶貝智慧聲控服務的線上體驗。您將可以親自感受到i寶貝智慧聲控的服務。" />
				<meta property="og:image" content="https://ibobby.ai.hinet.net/app_icons/app_banner/imgUpload_496bf11d-5c35-41c7-b18c-894e7331f961.png" />
			</MetaTags>
			<div className="tab tab_smart">
				<div className="pagesize">
					<div className="tab_main">
						<div className="tab_a ts_01 select"><a></a></div>
						<div className="tab_a ts_02"><a></a></div>
						<div className="tab_a ts_03"><a></a></div>
						<div className="tab_a ts_04"><a></a></div>
					</div>
				</div>
			</div>
			<div className="content_inpage">
				<div className="pagesize">
					<ul className="bread">
						<li><a href="/">首頁</a></li>
						<li><a href="/container/smart">親聲體驗</a></li>
					</ul>
					<div className="tab_con">
						<div className="tab_box active">
							<h2 className="tit_main">親聲體驗</h2>
							<div style={{ color: "#e61616" }}>●實際聲控使用需有喚醒詞&quot;i寶貝&quot;作為開啟指令辨識</div><br />

							<div id="smart_box">
								<div className="iframe_box">
									<iframe title="ibobbychatbot" style={{ height: "1100px" }} allow="microphone" src="https://ibobbychatbot.ai.hinet.net/"></iframe>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Smart;